<template>
  <report-list-page
      v-if="checkAccess('sites')"
      page-title="Site Report"
      page-icon="business"
      :descending="true"
      :headers="headers"
      state-end-point="invoice.invoices"
      :actions="actions"
      :show-component="showComponent"
      item-key="detailId"
      sort="invoiceNo"
  />
</template>

<script>
import IsAuthenticated from "../../middleware/IsAuthenticated";
import ReportListPage from "../../components/ReportListPage";
export default {
  name: "SiteReport",
  components: {ReportListPage},
  mixins:[IsAuthenticated],
  data() {
    return {
      headers: [
        {
          text: 'ID',
          value: 'invoiceNo'
        },
        {
          text: 'Date',
          value: 'createdAt'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Status',
          align: 'left',
          value: 'paymentStatus',
          sortable: false
        },
        {
          text: 'Site',
          value: 'site',
          sortable: false
        },
        {
          text: 'Publishable Amount',
          align: 'right',
          value: 'publishableAmount'
        },
        {
          text: 'Writing Price',
          align: 'right',
          value: 'articleWritingPrice'
        },
        {
          text: 'Sub Total',
          align: 'right',
          value: 'total'
        },
        {
          text: 'Discount',
          align: 'right',
          value: 'discount'
        },
        {
          text: 'Total',
          align: 'right',
          value: 'excludeDiscountTotal'
        }
      ],
      actions: {
        load: 'loadInvoiceReportBySite',
      },
      showComponent: {
        isUser: true,
        isStatus: true,
        isMethod: false,
        isEmail: true,
        isSite: true
      }
    }
  }
}
</script>

<style scoped>

</style>